/**
* @Author: Michael Neumair <mBook>
* @Date:   2016-09-27T10:46:06+02:00
* @Email:  7q7w7e7r@gmail.com
* @Last modified by:   mBook
* @Last modified time: 2016-10-05T17:50:12+02:00
*/


import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Control, Errors} from 'react-redux-form/src';
import MLabelInput from './../components/MLabelInput';
import AErrorInput from './../components/AErrorInput';
import MErrorGroupInput from './../components/MErrorGroupInput';
import MInputText from './../components/MInputText';
import shouldShowErrors from './shouldShowErrors';

/**
 * OInputFieldText - …
**/
class OInputFieldText extends Component {
  render() {
    const {
      model,
      defaultValue,
      disabled,
      placeholder,
      validators,
      validateOn,
      asyncValidators,
      messages,
      showErrors,
      unit,
      label,
      description,
      toolLabel,
      toolIcon,
      onPressTool,
      changeAction,
      maxLength,
      onPaste,
      autoComplete,
    } = this.props;

    return (
      <div className="o-input-field o-input-field-text">
        <MLabelInput
          htmlFor={model}
          label={label}
          description={description}
          toolLabel={toolLabel}
          toolIcon={toolIcon}
          onPressTool={onPressTool}
          disabled={disabled}
        />
        <Control.text
          model={model}
          defaultValue={defaultValue}
          component={MInputText}
          validators={validators}
          validateOn={validateOn}
          asyncValidators={asyncValidators}
          placeholder={placeholder}
          withFieldValue={true}
          showErrors={showErrors} // forces rerender when a value chagne - needed
          controlProps={{
            id: model,
            disabled,
            placeholder,
            unit,
            maxLength,
            autoComplete,
          }}
          mapProps={{
            error: (props) => shouldShowErrors(showErrors, props),
          }}
          changeAction={changeAction}
          onPaste={onPaste}
        />
        <Errors
          model={model}
          messages={messages}
          wrapper={MErrorGroupInput}
          component={AErrorInput}
          show={showErrors}
        />
      </div>
    );
  }
}
OInputFieldText.propTypes = {
  /**
     * react-redux-form model
     * see: https://davidkpiano.github.io/react-redux-form/docs/guides/models.html
     */
  model: PropTypes.string.isRequired,
  /**
     * default value of the component
     */
  defaultValue: PropTypes.number,
  /**
     * disable the input
     */
  disabled: PropTypes.bool,
  /**
     * placeholder for input
     */
  placeholder: PropTypes.string,
  /**
     * hash with validator functions
     * see: https://davidkpiano.github.io/react-redux-form/docs/guides/validation.html
     */
  validators: PropTypes.object,
  /**
     * when validation should be fired
     * see: https://davidkpiano.github.io/react-redux-form/docs/guides/validation.html
     */
  validateOn: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
  ]),
  /**
     * hash with async validator functions
     * see: https://davidkpiano.github.io/react-redux-form/docs/guides/validation.html
     */
  asyncValidators: PropTypes.object,
  /**
     * error messages for validatiors
     * see: https://davidkpiano.github.io/react-redux-form/docs/guides/validation.html
     */
  messages: PropTypes.object,
  /**
     * when errors should be shown
     * function which gets passed the props of the form-model
     * see: https://davidkpiano.github.io/react-redux-form/docs/api/Errors.html#show
     */
  showErrors: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.bool,
  ]).isRequired,
  /**
     * display a unit on the right
     */
  unit: PropTypes.string,
  /**
     * label and children are the same
     */
  label: PropTypes.string,
  /**
     * description for the input
     */
  description: PropTypes.any,
  /**
     * label for the tool-button, like 'Help'
     */
  toolLabel: PropTypes.string,
  /**
     * icon for the tool button like 'question-sign'
     */
  toolIcon: PropTypes.string,
  /**
     * displays a tool button with icon and fires
     * whe it is pressed. useful to show extra help infos
     */
  onPressTool: PropTypes.func,

  /**
     * limit input length on frontend via dom node
     */
  maxLength: PropTypes.number,
  /**
     * onPaste event
     */
  onPaste: PropTypes.func,
};
OInputFieldText.defaultProps = {
  validateOn: 'blur',
  showErrors: true,
  maxLength: null,
};
export default OInputFieldText;

